import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=260fdf38&scoped=true"
import script from "./ViewDocument.vue?vue&type=script&lang=js"
export * from "./ViewDocument.vue?vue&type=script&lang=js"
import style0 from "./ViewDocument.vue?vue&type=style&index=0&id=260fdf38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260fdf38",
  null
  
)

export default component.exports